module.exports = __webpack_public_path__ + "img/xsyb2.792b4922.jpg";